import { ChevronDownIcon } from "@heroicons/react/24/outline";
import React from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

type LanguageSelectorProps = {
  className?: string;
};

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  className,
}) => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <div className={twMerge("relative", "inline-block", className)}>
      <select
        value={i18n.language}
        onChange={handleLanguageChange}
        className="appearance-none bg-transparent text-gray-600 text-sm pr-6 border-none outline-none cursor-pointer"
      >
        {/* eslint-disable-next-line i18next/no-literal-string */}
        <option value="de">Deutsch</option>
        {/* eslint-disable-next-line i18next/no-literal-string */}
        <option value="en">English</option>
      </select>
      <ChevronDownIcon className="absolute right-0 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-600 pointer-events-none" />
    </div>
  );
};
